<template>
	<section class="track-alerts" id="main-wrap">
		<div class="content-wrapper">  
			<div class="container">
				<div class="heading-row">
					<h2 class="page-heading">Track alerts</h2>
				</div>
				<div class="track-area">
					<div class="top-menu">
						<input type="text" id="filter-text-box" v-model="searchQuery" @input="updateSearchQuery(searchQuery)" placeholder="Search..."  />
						<button @click="onBtExport()" class="download-btn"><img src="download.svg" alt=""></button>
					</div>		
					<!-- TABLE ACTION ROW -->
					<ag-grid-vue style="width: 100%; height: 80vh;"
					class="ag-theme-material"
					:gridOptions="gridOptions"
					:columnDefs="columnDefs"
					:defaultColDef="defaultColDef"
					:rowData="rowData"				
					rowSelection="multiple"
					:enableRangeSelection="true"
					:suppressCopyRowsToClipboard="true"
					colResizeDefault="shift"
					:suppressDragLeaveHidesColumns="true"
					:animateRows="true"
					:floatingFilter="true"
					:pagination="true"
					:paginationPageSize="paginationPageSize"
					:rowHeight="rowHeight"
					@column-resized="onColumnResized">		
					</ag-grid-vue>
				</div>			
			</div>
		</div>
	</section>				
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { setTimeout } from 'timers';
export default {
	name: 'HomeView',
		components: {
		AgGridVue
	},
	data(){
		return {
				gridOptions: null,
				gridApi: null,			
				columnDefs: null,
				rowData: null,
				paginationPageSize:null,
				defaultColDef: null,
				rowHeight: null,
				searchQuery: '',			
			}
	},

	beforeMount() {
		this.gridOptions = {};
		this.columnDefs = [
			{
				headerName: 'URL',
				field: 'keyword.url',
				minWidth: 130,
				width: 130,
				filter: "agTextColumnFilter",
				cellClass: "cell-wrap-text",
				pinned: 'left'
			},			
			{
				headerName: 'Article title',
				field: 'article_title',
				minWidth: 200,
				filter: "agTextColumnFilter",
				cellClass: "cell-wrap-text",
				cellRenderer: addUrl
				
			},
			{
				headerName: 'Article url',
				field: 'article_url',
				minWidth: 200,
				filter: "agTextColumnFilter",
				cellClass: "cell-wrap-text hidden-url",
				hide: true
			},
			{
				headerName: 'Description',
				field: 'snippet',
				minWidth: 200,
				filter: "agTextColumnFilter",
				cellClass: "cell-wrap-text",	
				autoHeight: true	 
			},
			{
				headerName: 'Created at',
				field: 'created_at',
				minWidth: 100,
				width: 100,
				filter: "agTextColumnFilter",
				cellClass: "cell-wrap-text",
				
			}				
		];
		this.defaultColDef = {
			sortable: true,
			resizable: true
		};
		this.paginationPageSize = 15;	
		this.rowHeight = 275;		
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		window.api= this.gridApi;

		if (process.env.NODE_ENV == 'development') {
			fetch("http://172.16.153.161:8000/api/mentions")
			//.then(result => console.log(result))
		  	.then(result => result.json())
		  	.then(rowData => (this.rowData = rowData));
		} else {
			fetch("https://alerts.rdxstg.host/api/mentions")
			//.then(result => console.log(result))
			.then(result => result.json())
			.then(rowData => (this.rowData = rowData));
		}
		this.sizeColumnsToFit(); 		
	},
	methods:{
		// Resize to fit columns
		sizeColumnsToFit() {
			this.gridApi.sizeColumnsToFit();
		},
		onColumnResized() {
			this.gridApi.resetRowHeights();
		},
		onBtExport(){
			 var params = {
				allColumns: true,
				fileName: 'media-mentions-report'
			 }
			this.gridApi.exportDataAsCsv(params);
		},
		updateSearchQuery(val) {
			//console.log (val);		
			this.gridApi.setQuickFilter(val);			
		},
	},	

}
var addUrl = function(params){
	//console.log(params);
	var url = params.data.article_url; 
	return "<a href="+url+" target='_blank' class='article-url'>"+params.value+"</a>";
};

</script>


